module.exports = __webpack_public_path__ + "static/media/19ESCAP12.1212c45f.jpg";